export default __webpack_public_path__ + "static/media/unarchive_prospects1.9ef0338d.png";